"use client"
import { useRouter } from 'next/navigation';
import React, { useState } from 'react'
import { useViewListStore } from '../../../store/viewList';
import { useQuery } from "@tanstack/react-query";
import { fetchItemDetails } from '../../../app/apis/getApis';
import { ViewList } from '../ViewList';


const ViewListClient = ({paramId}) => {
    const [isMounted, setIsMounted] = useState(false);
    const router = useRouter();
    const viewList = useViewListStore((state: any) => state?.viewList);
    const setViewList = useViewListStore((state: any) => state?.setViewList);


      const FetchItemDetails = useQuery({
        queryKey: ["itemDetails", paramId],
        queryFn: () => fetchItemDetails(paramId),
        enabled: !!paramId?.toString(),
        onSuccess: (data: any) => {
          setIsMounted(true);
          const fetchedData = data?.data?.body?.data;
          console.log(fetchedData, "fetchedData");
    
          setViewList({
            image: fetchedData.item.itemImages[0],
            listing_title: fetchedData.listing_title,
            online_price: fetchedData.online_price,
            online_discount: fetchedData.online_discount,
            online_discount_unit: fetchedData.online_discount_unit,
            listing_id: fetchedData.listing_id,
            item: fetchedData.item,
            effective_price: fetchedData?.effective_price,
          });
        },
        onError: (error: any) => {
          (error.response.status === 404 || error.response.status === 500) &&
            router.replace("/404");
        },
      });
    

  return (
    <>
      {viewList?.length > 1 && (
        <ViewList paramId={paramId} relatedProducts={viewList} />
      )}
    </>
  );
}

export default ViewListClient;